var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMouth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "6px",
    viewBox: "0 0 11 6",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Mouth") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Humanuculus",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    fillOpacity: 0.195858829
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard-Copy-28",
    transform: "translate(-210.000000, -71.000000)",
    fill: "#1E428A"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Front-Body---Selections",
    transform: "translate(175.074098, 42.681852)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Mouth---round",
    x: 34.925902,
    y: 28.3181483,
    width: 11,
    height: 6,
    rx: 2.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMouth);
export default __webpack_public_path__ + "static/media/Mouth.67030869783f4a78ed5cec1c48676590.svg";
export { ForwardRef as ReactComponent };